import { createContext, useState } from 'react';

export const YoutubeIframeApiContext = createContext({
  isReady: false,
  setIsReady: (bool: boolean) => {},
});

const YoutubeIframeApiProvider: React.ReactFCWithChildren<{}> = ({ children }) => {
  const [isReady, setIsReady] = useState(false);

  return <YoutubeIframeApiContext.Provider value={{ isReady, setIsReady }}>{children}</YoutubeIframeApiContext.Provider>;
};

export default YoutubeIframeApiProvider;
